module.exports = __webpack_public_path__ + "static/media/vericastlogo.64d24690.png";